export default {
  init() {
    $('.region-filter').on('change', function () {
      var url = window.location.href;
      var urlsplit = url.split('/');
      var branch = urlsplit[urlsplit.length - 2];

      $.ajax({
        // eslint-disable-next-line no-undef
        url: ajax_object.ajax_url,
        method: 'POST',
        data: {
          value: this.value,
          branch: branch,
          action: 'call_ministries',
        },
        success: function (response) {
          console.log(response);
        },
        error: function (response) {
          console.log(response);
        },
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateBranch.js